import { FC } from "react";
import SvgCsvExport from "../icons/CsvExport";
import SvgExcelExport from "../icons/ExcelExport";
import styles from "./ExportButton.module.css";

type ExportFormat = "excel" | "csv";

type ExportButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

type BaseExportButtonProps = ExportButtonProps & {
  format: ExportFormat;
};

type ExportButtonComponent = FC<BaseExportButtonProps> & {
  Excel: FC<ExportButtonProps>;
  Csv: FC<ExportButtonProps>;
};

const BaseExportButton: FC<BaseExportButtonProps> = ({ onClick, format, disabled }) => {
  const Icon = format === "excel" ? SvgExcelExport : SvgCsvExport;
  const label = format === "excel" ? "Excel" : "Csv";

  return (
    <button className={styles.button} onClick={onClick} disabled={disabled} type="button">
      <Icon className={styles.icon} />
      {label}
    </button>
  );
};

const ExportButton = Object.assign(BaseExportButton, {
  Excel: (props: ExportButtonProps) => <BaseExportButton {...props} format="excel" />,
  Csv: (props: ExportButtonProps) => <BaseExportButton {...props} format="csv" />,
}) as ExportButtonComponent;

export default ExportButton;
